import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@jordan/ui';
import { useMe } from './MeProvider';

/** Restrict a route to ADMIN users; redirects others to the dashboard. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const me = useMe();
  if (me === undefined) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner />
      </div>
    );
  }
  if (!me || me.role !== 'ADMIN') return <Navigate to="/" replace />;
  return <>{children}</>;
}
